<template>
  <MasterLeads />
</template>
<script>
import MasterLeads from '@/modules/master/leads/Leads.vue'

export default {
  components: { MasterLeads },
}
</script>
